export * from "./freeCameraDeviceOrientationInput.types";
/**
 * Re-exports pure implementation and applies runtime side effects.
 * Import freeCameraDeviceOrientationInput.pure for tree-shakeable, side-effect-free usage.
 */
export * from "./freeCameraDeviceOrientationInput.pure";

import { RegisterFreeCameraDeviceOrientationInput } from "./freeCameraDeviceOrientationInput.pure";
RegisterFreeCameraDeviceOrientationInput();
